import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useMemo } from "react";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { myappSubNav } from "@/lib/navigationItems";
import { usePairingAccess } from "@/hooks/usePairingAccess";

export const Route = createFileRoute("/portal/myapp")({
  component: MyAppLayout,
});

function MyAppLayout() {
  // Pairing tab visibility follows the same access model the Pairing page
  // enforces (owners/admins, or a granted Tier-4 member) rather than the old
  // static org-owner-only role gate — see usePairingAccess. Hidden while the
  // grant answer is still resolving so it doesn't flash then vanish.
  const { visible: pairingVisible } = usePairingAccess();
  const [items, hiddenItems] = useMemo(
    () =>
      pairingVisible
        ? [myappSubNav, []]
        : [
            myappSubNav.filter((i) => i.id !== "myapp-bridge"),
            myappSubNav.filter((i) => i.id === "myapp-bridge"),
          ],
    [pairingVisible],
  );

  return (
    <div className="space-y-4">
      {/* The hidden Pairing tab still owns /portal/myapp/bridge: without it in
          the scan, Tables' /portal/myapp/ pattern would light up there. */}
      <ProductSubNav items={items} hiddenItems={hiddenItems} />
      <Outlet />
    </div>
  );
}
